import Bowser from 'bowser';
import Cookies from 'js-cookie';
import BrowserNotSupportedModal from '../modals/BrowserNotSupportedModal';

class BrowserSupport {
  constructor() {
    this.browser = Bowser.getParser(window.navigator.userAgent);
  }

  supported() {
    return this.browser.satisfies({
      'internet explorer': '>12',
      firefox: '>35',
      chrome: '>60',
      safari: '>10',
      edge: '>=75',

      mobile: {
        safari: '>10',
        'android browser': '>= 4.4.4',
      },
    });
  }

  check() {
    if (!this.supported() && !this.dismissed()) {
      try {
        const modal = new BrowserNotSupportedModal();
        modal.on('hide', () => {
          this.dismiss();
        });
        modal.show();
      } catch (e) {
        // Modal not found in the DOM, fail silently
      }
    }
  }

  dismissed() {
    return Cookies.get('unsupported_browser_dismissed') === 'true';
  }

  dismiss() {
    Cookies.set('unsupported_browser_dismissed', 'true', { expires: 7 });
  }
}

const browserSupport = new BrowserSupport();

export default () => {
  return browserSupport;
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/browserSupport.js